<header class="pmm-header">
  <div class="nav-inner">
    <!-- Logo -->
    <a routerLink="/" class="pmm-logo">
      <img src="assets/images/logotipo-pmm-azul.svg" alt="PMM Paquetería y Mensajería" class="pmm-logo-img" width="355" height="132">
    </a>

    <!-- Navegación Desktop -->
    <nav class="nav-links" aria-label="Navegación principal">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Inicio</a>

      <div class="nav-drop">
        <button type="button" class="nav-drop-btn" aria-haspopup="true">Servicios ▾</button>
        <div class="nav-dropdown">
          <div class="drop-col">
            <div class="drop-section">Opciones de Entrega</div>
            <a routerLink="/servicios/entrega-dom"><strong>Entrega a Domicilio</strong><span>Llevamos tu mercancía directo a la puerta.</span></a>
            <a routerLink="/servicios/ocurre"><strong>Servicio Ocurre</strong><span>Recoge en la sucursal más cercana.</span></a>
            <a routerLink="/servicios/detalle"><strong>Entrega a Detalle</strong><span>Logística especializada e inventariada.</span></a>
          </div>
          <div class="drop-col">
            <div class="drop-section">Trámites y Seguridad</div>
            <a routerLink="/servicios/acuse"><strong>Acuse de Recibo</strong><span>Comprobante físico de entrega exitosa.</span></a>
            <a routerLink="/servicios/valor-declarado"><strong>Valor Declarado</strong><span>Seguro de mercancía para tus productos.</span></a>
            <a routerLink="/servicios/retorno"><strong>Retorno Evidencias</strong><span>Devolución de documentos firmados.</span></a>
          </div>
          <div class="drop-col">
            <div class="drop-section">Envíos Especiales</div>
            <a routerLink="/recoleccion"><strong>Recolección a Domicilio</strong><span>Recogemos tus paquetes en tu negocio u hogar.</span></a>
            <a routerLink="/servicios/cobrar"><strong>Servicio a Cobrar</strong><span>El destinatario paga al recibir.</span></a>
          </div>
        </div>
      </div>

      <a routerLink="/cobertura" routerLinkActive="active">Cobertura</a>

      <div class="nav-drop">
        <button type="button" class="nav-drop-btn" aria-haspopup="true">Cliente ▾</button>
        <div class="nav-dropdown nav-dropdown--client">
          <a *ngFor="let link of clientLinks" [href]="link.href" target="_blank" rel="noopener noreferrer">
            <strong>{{ link.label }}</strong><span>{{ link.desc }}</span>
          </a>
        </div>
      </div>
    </nav>

    <!-- Acciones derecha -->
    <div class="nav-right">
      <a href="tel:6699158500" class="nav-phone">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
        669 915 8500
      </a>
      <a href="https://pmm.com.mx/tiendapmm" class="btn-tienda">Tienda</a>
      <button type="button" class="nav-toggle" (click)="toggleMobile()" [attr.aria-expanded]="mobileOpen" aria-label="Abrir menú">
        <svg *ngIf="!mobileOpen" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>
        <svg *ngIf="mobileOpen" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 18L18 6M6 6l12 12"/></svg>
      </button>
    </div>
  </div>

  <!-- Navegación Móvil -->
  <nav class="mobile-nav" [class.open]="mobileOpen" aria-label="Navegación móvil">
    <a routerLink="/" (click)="closeMobile()" class="m-link">Inicio</a>

    <button type="button" class="m-acc-btn" (click)="toggleMobileServices()" [attr.aria-expanded]="mobileServicesOpen">
      <span>Servicios</span>
      <svg class="m-chevron" [class.open]="mobileServicesOpen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
    </button>
    <div class="m-acc" *ngIf="mobileServicesOpen">
      <span class="m-acc-head">Opciones de Entrega</span>
      <a routerLink="/servicios/entrega-dom" (click)="closeMobile()">Entrega a Domicilio</a>
      <a routerLink="/servicios/ocurre" (click)="closeMobile()">Servicio Ocurre</a>
      <a routerLink="/servicios/detalle" (click)="closeMobile()">Entrega a Detalle</a>
      <span class="m-acc-head">Trámites y Seguridad</span>
      <a routerLink="/servicios/acuse" (click)="closeMobile()">Acuse de Recibo</a>
      <a routerLink="/servicios/valor-declarado" (click)="closeMobile()">Valor Declarado</a>
      <a routerLink="/servicios/retorno" (click)="closeMobile()">Retorno Evidencias</a>
      <span class="m-acc-head">Envíos Especiales</span>
      <a routerLink="/recoleccion" (click)="closeMobile()">Recolección a Domicilio</a>
      <a routerLink="/servicios/cobrar" (click)="closeMobile()">Servicio a Cobrar</a>
    </div>

    <a routerLink="/cobertura" (click)="closeMobile()" class="m-link">Cobertura</a>

    <button type="button" class="m-acc-btn" (click)="toggleMobileClient()" [attr.aria-expanded]="mobileClientOpen">
      <span>Cliente</span>
      <svg class="m-chevron" [class.open]="mobileClientOpen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
    </button>
    <div class="m-acc" *ngIf="mobileClientOpen">
      <a *ngFor="let link of clientLinks" [href]="link.href" target="_blank" rel="noopener noreferrer" (click)="closeMobile()">{{ link.label }}</a>
    </div>

    <a href="tel:6699158500" class="m-link m-phone" (click)="closeMobile()">669 915 8500</a>
    <a href="https://pmm.com.mx/tiendapmm" class="btn-tienda m-tienda" (click)="closeMobile()">Tienda</a>
  </nav>
</header>
